import { Box, Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const wineTypeOptions = [
  "Merlot","Cabernet Sauvignon","Cabernet Franc","Syrah","Tannat",
  "Sauvignon Gris","Tinto","Rosé","Branco","Tempranillo","Brut","Semi Seco",
];
const brandOptions = [
  "Filgueira","Don Luciano","Cartuxa","Jaume Serra","Cave das Vertentes","Casa Geraldo","Alma Mineira",
];

const SectionLabel = ({ children }) => (
  <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
    {children}
  </Text>
);

export function WineFilters(props) {
  const location = useLocation();
  const [wineTypes, setWineTypes] = useState([]);
  const [brands, setBrands] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(types, activeBrands) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (activeBrands.length > 0) url += `&wine_brands=${activeBrands.join(',')}`;
    if (types.length > 0) url += `&wine_types=${types.join(',')}`;
    if (types.length === 0 && activeBrands.length === 0) {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleType(type) {
    const updated = wineTypes.includes(type) ? wineTypes.filter(t => t !== type) : [...wineTypes, type];
    setWineTypes(updated);
    filterProducts(updated, brands);
  }

  function toggleBrand(brand) {
    const updated = brands.includes(brand) ? brands.filter(b => b !== brand) : [...brands, brand];
    setBrands(updated);
    filterProducts(wineTypes, updated);
  }

  return (
    <>
      <SectionLabel>Tipos</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px" mb="20px">
        {wineTypeOptions.map((t, i) => (
          <FilterChip key={i} label={t} isActive={wineTypes.includes(t)} onClick={() => toggleType(t)} />
        ))}
      </Grid>

      <Box h="1px" bg="rgba(0,74,51,0.08)" mb="20px" />

      <SectionLabel>Marcas</SectionLabel>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {brandOptions.map((b, i) => (
          <FilterChip key={i} label={b} isActive={brands.includes(b)} onClick={() => toggleBrand(b)} />
        ))}
      </Grid>
    </>
  );
}
